export default __webpack_public_path__ + "static/media/season_summer.ee56785d.png";